import React from 'react';
import PropTypes from 'prop-types';

import 'rc-slider/assets/index.css';
import './VariableStepRange.sass';
import {Range} from 'rc-slider';

import cx from 'classnames';

export default class VariableStepRange extends React.PureComponent {
  static propTypes = {
    ...Range.propTypes,
    multipliers: PropTypes.arrayOf(PropTypes.shape({
      from: PropTypes.number.isRequired,
      to: PropTypes.number.isRequired,
      by: PropTypes.number.isRequired
    }))
  };

  static defaultProps = {multipliers: []};

  static mapValue = (value, multipliers) => {
    let originalValue = value;
    let mappedTotal = 0;

    for (let i = 0, len = multipliers.length; i < len; i++) {
      const multiplier = multipliers[i];
      let took = 0;

      if (value > multiplier.to) {
        took = multiplier.to - multiplier.from;
      } else if (value > multiplier.from) {
        took = value - multiplier.from;
      }

      originalValue -= took;
      mappedTotal += took * multiplier.by;
    }

    return Math.round(originalValue + mappedTotal);
  };

  constructor(props) {
    super(props);

    this.state = {
      reverseMultipliers: props.multipliers.map(multiplier => ({
        by: 1 / multiplier.by,
        from: VariableStepRange.mapValue(multiplier.from, props.multipliers),
        to: VariableStepRange.mapValue(multiplier.to, props.multipliers)
      })),
      max: VariableStepRange.mapValue(props.max, props.multipliers),
      marks: props.marks && Object.keys(props.marks).reduce((acc, key) => {
        acc[VariableStepRange.mapValue(Number(key), props.multipliers)] = props.marks[key];
        return acc;
      }, {})
    };
  }

  componentWillReceiveProps(nextProps) {
    const {multipliers, max, marks} = nextProps;
    const multipliersUpdated = multipliers !== this.props.multipliers;

    if (multipliersUpdated) {
      this.setState({
        reverseMultipliers: multipliers.map(multiplier => ({
          by: 1 / multiplier.by,
          from: VariableStepRange.mapValue(multiplier.from, multipliers),
          to: VariableStepRange.mapValue(multiplier.to, multipliers)
        }))
      });
    }

    if (multipliersUpdated || max !== this.props.max) {
      this.setState({
        max: VariableStepRange.mapValue(max, multipliers)
      });
    }

    if (multipliersUpdated || marks !== this.props.marks) {
      this.setState({
        marks: marks && Object.keys(marks).reduce((acc, key) => {
          acc[VariableStepRange.mapValue(Number(key), multipliers)] = marks[key];
          return acc;
        }, {})
      });
    }
  }

  handleValueCallback(callbackName, value) {
    const callback = this.props[callbackName];

    if (callback) {
      const {reverseMultipliers} = this.state;
      callback(value.map(it => VariableStepRange.mapValue(it, reverseMultipliers)));
    }
  }

  render() {
    const {max, marks} = this.state;

    const invalidRange = this.props.value.some((item, idx, ctx) => (idx < ctx.length - 1) && (item > ctx[idx + 1]));

    return (
      <Range
        allowCross={false}
        pushable={true}
        {...this.props}
        className={cx(this.props.className, invalidRange && 'rc-slider--invalid')}
        max={max}
        marks={marks}
        value={this.props.value.map(it => VariableStepRange.mapValue(it, this.props.multipliers))}
        onBeforeChange={value => this.handleValueCallback('onBeforeChange', value)}
        onChange={value => this.handleValueCallback('onChange', value)}
        onAfterChange={value => this.handleValueCallback('onAfterChange', value)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/controls/variableStepRange/VariableStepRange.js